export interface NavLink {
  label: string;
  href: string;
}

export interface QuickTag {
  label: string;
  icon: string;
  tone: 'primary' | 'accent' | 'secondary';
}

export interface StatItem {
  value: string;
  label: string;
}

export interface HotItem {
  rank: number;
  title: string;
  tag: string;
  heat: string;
  trend: 'up' | 'down' | 'flat';
}

export interface CollectionItem {
  id: string;
  title: string;
  desc: string;
  tags: string[];
  count: string;
  update: string;
  tone: 'primary' | 'accent' | 'secondary';
  icon: string;
}

export interface TopicGroup {
  group: string;
  desc: string;
  tags: string[];
}

export interface FeedItem {
  id: string;
  title: string;
  category: string;
  time: string;
  views: string;
}

export interface MaterialItem {
  name: string;
  type: string;
  size: string;
  count: string;
  tone: 'primary' | 'accent' | 'secondary';
  icon: string;
}

export interface GuideStep {
  step: string;
  title: string;
  desc: string;
  icon: string;
}

export interface FaqItem {
  q: string;
  a: string;
}

export const navLinks: NavLink[] = [
  { label: '精选合集', href: '#collections' },
  { label: '瓜料热榜', href: '#hot' },
  { label: '内容大全', href: '#feed' },
  { label: '素材库', href: '#materials' },
  { label: '话题墙', href: '#topics' },
];

export const quickTags: QuickTag[] = [
  { label: '今日更新', icon: 'ri-flashlight-fill', tone: 'accent' },
  { label: '编辑精选', icon: 'ri-medal-fill', tone: 'primary' },
  { label: '全网热词', icon: 'ri-fire-fill', tone: 'accent' },
  { label: '合集上新', icon: 'ri-box-3-fill', tone: 'secondary' },
  { label: '素材整包', icon: 'ri-folder-download-fill', tone: 'primary' },
];

export const stats: StatItem[] = [
  { value: '1,286', label: '已收录精选合集' },
  { value: '9,4K+', label: '累计浏览收藏' },
  { value: '每日', label: '人工滚动更新' },
  { value: '免登录', label: '点开即可浏览' },
];

export const hotItems: HotItem[] = [
  { rank: 1, title: '年度爆款剧大结局前瞻，导演透露关键伏笔', tag: '瓜料', heat: '1.28M', trend: 'up' },
  { rank: 2, title: '顶流演唱会二次开售，票务规则更新整理', tag: '资讯', heat: '1.09M', trend: 'up' },
  { rank: 3, title: '新综艺阵容官宣，网友剪辑混剪快速上手', tag: '瓜料', heat: '986K', trend: 'up' },
  { rank: 4, title: '城市夜宵探店合集，评论区口碑一次看全', tag: '合集', heat: '752K', trend: 'up' },
  { rank: 5, title: '直播间秒杀清单汇总，开播提醒不迷路', tag: '资讯', heat: '641K', trend: 'flat' },
  { rank: 6, title: '爆款短视频文案模板，起号阶段可参考', tag: '素材', heat: '523K', trend: 'down' },
  { rank: 7, title: '热搜话题背后的时间线梳理，吃瓜更清晰', tag: '瓜料', heat: '417K', trend: 'up' },
  { rank: 8, title: '周末片单盘点：口碑与话题兼顾的高分选择', tag: '合集', heat: '365K', trend: 'flat' },
  { rank: 9, title: '数码新品发布汇总，参数对比一张表看懂', tag: '资讯', heat: '298K', trend: 'down' },
  { rank: 10, title: '表情包与海报素材合集，商用前记得核对授权', tag: '素材', heat: '231K', trend: 'up' },
];

export const collections: CollectionItem[] = [
  {
    id: 'c1', title: '明星同款穿搭合集', desc: '把近期热议的造型灵感按场景收拢成包，通勤、活动、街拍一目了然。',
    tags: ['穿搭', '明星同款', '街拍'], count: '86 篇', update: '2 小时前', tone: 'accent', icon: 'ri-shirt-fill',
  },
  {
    id: 'c2', title: '全网爆款表情包素材', desc: '热门反应与日常斗图整包整理，风格标注齐全，浏览收藏更方便。',
    tags: ['表情包', '斗图', '热门'], count: '320 张', update: '今日', tone: 'primary', icon: 'ri-emotion-happy-fill',
  },
  {
    id: 'c3', title: '短视频起号标题灵感库', desc: '按行业拆分的标题句式与钩子，起号选题不再从零开始。',
    tags: ['短视频', '文案', '标题'], count: '210 条', update: '昨日', tone: 'secondary', icon: 'ri-quill-pen-fill',
  },
  {
    id: 'c4', title: '节假日热点内容包', desc: '把节日相关的热词、话题与可复用角度汇总，提前准备不慌。',
    tags: ['节日', '营销', '热词'], count: '54 包', update: '3 天前', tone: 'secondary', icon: 'ri-calendar-check-fill',
  },
  {
    id: 'c5', title: '开箱测评选题合集', desc: '数码、家居、美妆品类的新品开箱话题，追踪进度随时跟进。',
    tags: ['测评', '数码', '选题'], count: '42 条', update: '1 天前', tone: 'primary', icon: 'ri-box-2-fill',
  },
  {
    id: 'c6', title: '短剧分镜脚本素材包', desc: '常见桥段的镜头拆解与分镜参考，给创作灵感兜个底。',
    tags: ['短剧', '分镜', '脚本'], count: '68 份', update: '本周', tone: 'accent', icon: 'ri-film-fill',
  },
];

export const topicGroups: TopicGroup[] = [
  {
    group: '吃瓜榜话题', desc: '近段时间讨论度靠前的讨论议题，按热度滚动。',
    tags: ['综艺名场面', '年度爆款剧', '舞台路透', '新剧官宣', '红毯造型', '真人秀片段', '演唱会现场', '幕后花絮'],
  },
  {
    group: '内容大类', desc: '91免费内容大全的常用分类入口，按需直达对应区块。',
    tags: ['瓜料汇总', '娱乐资讯', '明星动态', '影视新作', '综艺现场', '音乐榜单', '时尚潮流', '生活日常'],
  },
  {
    group: '素材关键词', desc: '与资源整理相关的常用词，方便按关键词筛内容包。',
    tags: ['表情包', '海报模板', '封面图', '文案句式', 'BGM 歌单', '滤镜风格', '分镜脚本', '口播稿'],
  },
  {
    group: '热度玩法', desc: '常被拿来二次讨论的话题玩法，浏览收藏两不误。',
    tags: ['最强弹幕', '名场面重演', '神评论', '还原挑战', '慢放解析', '路人视角', '考古考古', '二创混剪'],
  },
];

export const feedTabs: string[] = ['全部', '瓜料', '资讯', '合集', '素材'];

export const feedItems: FeedItem[] = [
  { id: 'f1', title: '这一季口碑出圈的几部，都在聊什么看点', category: '瓜料', time: '09-06 12:30', views: '88.2万' },
  { id: 'f2', title: '节假日促销节点日历更新，提前收藏备查', category: '资讯', time: '09-06 11:05', views: '41.7万' },
  { id: 'f3', title: '近期热议的穿搭风格盘点，同款怎么找不踩雷', category: '合集', time: '09-06 09:48', views: '56.3万' },
  { id: 'f4', title: '新手向剪辑封面图素材，规格与配色都标好了', category: '素材', time: '09-06 08:20', views: '29.6万' },
  { id: 'f5', title: '一档新综艺阵容公布，讨论区都在刷什么', category: '瓜料', time: '09-05 22:10', views: '73.9万' },
  { id: 'f6', title: '本周数码新品汇总，值不值得蹲守看这里', category: '资讯', time: '09-05 18:44', views: '47.1万' },
  { id: 'f7', title: '开箱测评合集持续更新，欢迎按品类收藏', category: '合集', time: '09-05 15:32', views: '22.8万' },
  { id: 'f8', title: '日常斗图表情包上新，热门梗已整理成包', category: '素材', time: '09-05 10:16', views: '61.4万' },
];

export const materials: MaterialItem[] = [
  { name: '封面图模板包', type: '图片模板', size: '128MB', count: '1.2万次', tone: 'accent', icon: 'ri-image-2-fill' },
  { name: '口播脚本句式', type: '文案文本', size: '1.4MB', count: '6.8千次', tone: 'primary', icon: 'ri-file-text-fill' },
  { name: '剪辑BGM歌单', type: '音频歌单', size: '3.6GB', count: '9.1千次', tone: 'secondary', icon: 'ri-music-2-fill' },
  { name: '海报拆解思路', type: '参考文档', size: '24MB', count: '4.3千次', tone: 'secondary', icon: 'ri-layout-masonry-fill' },
  { name: '高热度表情包', type: '图片整包', size: '460MB', count: '1.6万次', tone: 'accent', icon: 'ri-emotion-laugh-fill' },
  { name: '滤镜调色预设', type: '预设文件', size: '88MB', count: '5.2千次', tone: 'primary', icon: 'ri-settings-3-fill' },
];

export const guideSteps: GuideStep[] = [
  { step: '01', title: '按板块直达', desc: '顶部导航与快捷入口，直接跳到合集、热榜、素材对应分区。', icon: 'ri-navigation-fill' },
  { step: '02', title: '按标签筛选', desc: '话题墙与分类标签，点选即可定位到想看的那一类内容。', icon: 'ri-price-tag-3-fill' },
  { step: '03', title: '按热度收藏', desc: '榜单与热度标注意见直观，高频内容集中在一起方便收藏。', icon: 'ri-bookmark-fill' },
  { step: '04', title: '一键整包浏览', desc: '内容包与素材包按主题整理好，点开即可一次性浏览全部条目。', icon: 'ri-box-3-fill' },
];

export const faqs: FaqItem[] = [
  {
    q: '91免费精选合集的内容从哪里整理？',
    a: '站内合辑主要来自对公开热议内容的二次汇总与归类，按话题与素材类型打包，方便集中浏览，不代替原平台与原作者。',
  },
  {
    q: '浏览这些内容需要登录或下载 App 吗？',
    a: '不需要。本站为内容导航整理单页，绝大多数合集与榜单点开即可直接浏览，静默收藏无需注册。',
  },
  {
    q: '素材库里的内容可以直接商用吗？',
    a: '每份素材包的授权范围不同，素材条目旁已尽量标注来源与授权提示，商用前请务必自行核对原始授权说明。',
  },
  {
    q: '精选合集多久更新一次？',
    a: '内容与热度榜单保持滚动更新，热门瓜料、新合集与素材上新会尽可能第一时间补进对应分区。',
  },
  {
    q: '为什么有的标题没有配图？',
    a: '本站以标题与话题优先，尽量克制配图、降低干扰，让你一眼定位到想看的那一条，需要素材时再进入素材库查看。',
  },
];